module.exports = __webpack_public_path__ + "static/img/kefuImg.f12e678d.png";